<template>
  <w-icon-wrapper
    :height='24.018'
    :width='23.734'
    icon-name='work-history-icon'
    view-box='0 0 23.734 24.018'
  >
    <g
      id='_3_Historie_Icon'
      data-name='3 Historie_Icon'
      transform='translate(-0.27 0.001)'
    >
      <path
        id='Pfad_55646'
        d='M23.7,9.354A12.018,12.018,0,0,0,9.347.3a12.162,12.162,0,0,0-1.8.557,11.839,11.839,0,0,0-3.924,2.57V1.487a1,1,0,0,0-2,0v5.2h5.2a1,1,0,0,0,0-2H5.2A9.863,9.863,0,0,1,8.287,2.712a10.266,10.266,0,0,1,1.5-.465A10.008,10.008,0,1,1,2.246,14.216a1,1,0,0,0-1.951.443,12.015,12.015,0,0,0,11.684,9.358,12.105,12.105,0,0,0,2.673-.3A12,12,0,0,0,23.7,9.354Z'
        data-name='Pfad 55646'
        fill='currentColor'
      />
      <path
        id='Pfad_55647'
        d='M12,4.688a1,1,0,0,0-1,1v6.726l5.293,5.293a1,1,0,0,0,1.414-1.414L13,11.586v-5.9A1,1,0,0,0,12,4.688Z'
        data-name='Pfad 55647'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconHistory' };
</script>
